import { useWorkspacePanel } from '../../../panels/hooks/use-workspace-panel';
import { useEventMetadataStore } from '../../event-panel-form/event-metadata';
import {
    allEventPanelTabConfigs,
    externalAgencyEventPanelTabConfigs,
    newEventPanelTabConfigs,
    scheduledEventPanelTabConfigs,
} from './event-panel-tabs-config';

export function useEventPanelTabConfigs() {
    const workspacePanel = useWorkspacePanel<'EVENT'>();
    const eventId = workspacePanel.linkedEntityId;
    const isNewEvent = !eventId;
    const eventMetadataStore = useEventMetadataStore();
    const isScheduledEvent = eventMetadataStore.state.metadata?.isScheduledEvent;
    const isExternalAgencyEvent = eventMetadataStore?.state.metadata?.isAgencyExternal;
    if (isNewEvent) {
        return newEventPanelTabConfigs;
    } else if (isScheduledEvent) {
        return scheduledEventPanelTabConfigs;
    } else if (isExternalAgencyEvent) {
        return externalAgencyEventPanelTabConfigs;
    } else {
        return allEventPanelTabConfigs;
    }
}
